import axios from 'axios'
import url from '../../urls'
import router from '../../router'

export default {
  GET_EMPLOYEE_LIST({ commit }, { pageNumber, pageSize }) {
    commit('GET_EMPLOYEE_LIST_LOADING', true)
    axios({
      method: 'GET',
      url: url.GET_EMPLOYEE_LIST_URL,
      params: { pageNumber, pageSize }
    })
      .then(response => {
        commit('GET_EMPLOYEE_LIST_SUCCESS', response.data.result)
        commit('GET_EMPLOYEE_LIST_LOADING', false)
      })
      .catch(error => {
        if (error.response) {
          commit('GET_EMPLOYEE_LIST_ERROR', error.response.data.message)
          commit('GET_EMPLOYEE_LIST_LOADING', false)
        }
      })
  },
  GET_PERSONAL_INN_INFO({ commit }, data) {
    commit('SET_LOADING_PERSONAL_INN', true)
    return axios({
      url: `${url.GET_PERSONAL_INN_INFO_URL}`,
      method: 'GET',
      params: {
        organisationInn: data.organisationInn,
        employeeInn: data.employeeInn
      }
    })
      .then(response => {
        commit('GET_PERSONAL_NAME_SUCCESS', response.data)
        commit('SET_LOADING_PERSONAL_INN', false)
      })
      .catch(error => {
        commit('GET_PERSONAL_NAME_FAILURE', error.response)
        commit('SET_LOADING_PERSONAL_INN', false)
      })
  },
  GET_PERSONAL_INFO({ commit }, data) {
    commit('SET_LOADING_PERSONAL_INN', true)
    return axios({
      url: `${url.GET_INN_INFO}/${data}`,
      method: 'GET'
    })
      .then(response => {
        commit('GET_PERSONAL_NAME_SUCCESS', response.data)
        commit('SET_LOADING_PERSONAL_INN', false)
      })
      .catch(error => {
        commit('GET_PERSONAL_NAME_FAILURE', error.response)
        commit('SET_LOADING_PERSONAL_INN', false)
      })
  },
  GET_ORGANISATION_INFO({ commit }, data) {
    commit('SET_LOADING_ORGANISATION_INN', true)
    return axios({
      url: `${url.GET_INN_INFO}/${data}`,
      method: 'GET'
    })
      .then(response => {
        commit('GET_ORGANISATION_NAME_SUCCESS', response.data)
        commit('SET_LOADING_ORGANISATION_INN', false)
      })
      .catch(error => {
        commit('GET_ORGANISATION_NAME_FAILURE', error.response)
        commit('SET_LOADING_ORGANISATION_INN', false)
      })
  },
  GET_DB_ACCESS_LIST({ commit }) {
    axios({
      url: url.GET_DB_ACCESS_LIST_URL,
      method: 'GET'
    })
      .then(response => {
        commit('GET_DB_ACCESS_LIST_SUCCESS', response.data)
      })
      .catch(error => {
        if (error.response) {
          commit('GET_DB_ACCESS_LIST_ERROR', error.response.data.message)
        }
      })
  },
  GET_DB_LIST_FOR_NEW_EMPLOYEE({ commit }) {
    axios({
      method: 'GET',
      url: url.GET_DB_LIST_FOR_NEW_EMPLOYEE_URL
    })
      .then(response => {
        commit('GET_DB_LIST_FOR_NEW_EMPLOYEE_SUCCESS', response.data.result)
      })
      .catch(error => {
        commit('GET_DB_LIST_FOR_NEW_EMPLOYEE_ERROR', error.response)
      })
  },
  DELETE_EMPLOYEE({ commit, dispatch }, id) {
    commit('DELETE_EMPLOYEE_LOADING', true)
    axios({
      method: 'DELETE',
      url: `${url.DELETE_EMPLOYEE_URL}/${id}`
    })
      .then(response => {
        commit('DELETE_EMPLOYEE_SUCCESS', response.data)
        commit('DELETE_EMPLOYEE_LOADING', false)
        dispatch('GET_EMPLOYEE_LIST')
      })
      .catch(error => {
        commit('DELETE_EMPLOYEE_ERROR', error)
        commit('DELETE_EMPLOYEE_LOADING', false)
      })
  },
  ADD_NEW_EMPLOYEE({ commit }, data) {
    commit('LOADING_ADD_NEW_EMPLOYEE', true)
    return axios({
      method: 'POST',
      url: url.ADD_NEW_EMPLOYEE_URL,
      data
    })
      .then(response => {
        if (response.status === 200 && response.statusText === 'OK') {
          router.push({ path: '/main/employee/list' })
        }
        // commit('ADD_NEW_EMPLOYEE_SUCCESS', response.data)
        commit('LOADING_ADD_NEW_EMPLOYEE', false)
      })
      .catch(error => {
        commit('ADD_NEW_EMPLOYEE_ERROR', error.response)
        commit('LOADING_ADD_NEW_EMPLOYEE', false)
      })
  },
  GET_EMPLOYEE_INFO_FOR_EDIT({ commit }, id) {
    axios({
      method: 'GET',
      url: `${url.GET_EMPLOYEE_INFO_FOR_EDIT_URL}/${id}`
    })
      .then(response => {
        commit('GET_EMPLOYEE_INFO_SUCCESS', response.data)
      })
      .catch(error => {
        commit('GET_EMPLOYEE_INFO_ERROR', error)
      })
  },
  EDIT_EMPLOYEE({ commit }, data) {
    commit('EDIT_EMPLOYEE_LOADING', true)
    axios({
      method: 'PUT',
      url: `${url.EDIT_EMPLOYEE_URL}${data.id}`,
      data: data.payload
    })
      .then(response => {
        commit('EDIT_EMPLOYEE_SUCCESS', response.data)
        commit('EDIT_EMPLOYEE_LOADING', false)
      })
      .catch(error => {
        commit('EDIT_EMPLOYEE_ERROR', error.response.data.message)
        commit('EDIT_EMPLOYEE_LOADING', false)
      })
  }
}



// WEBPACK FOOTER //
// ./src/store/employee/actions.js